import { useCallback } from "react";

type Pattern = number | readonly number[];

const supported = () =>
  typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

export function useVibration() {
  const vibrate = useCallback((pattern: Pattern) => {
    if (!supported()) return false;
    try {
      return navigator.vibrate(pattern as number | number[]);
    } catch {
      return false;
    }
  }, []);

  const cancel = useCallback(() => {
    if (!supported()) return;
    try {
      navigator.vibrate(0);
    } catch {
      /* noop */
    }
  }, []);

  return { vibrate, cancel, supported: supported() };
}

export const VibrationPatterns = {
  bellShake: [40, 40, 40, 40, 40, 40, 40],
  bellTap: 30,
  woodTap: [20, 30, 20],
  cardOpen: [60, 40, 100],
  daiKichi: [80, 40, 80, 40, 200],
  kyo: [200],
} as const;
